import React from "react"

function CloseIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg  width={15} height={15} viewBox="0 0 15 15" {...props}>
      <title>{"Close Button"}</title>
      <g stroke="#000000" strokeWidth={2} fill="none" fillRule="evenodd">
        <path d="M1 14L14 1M1 1l13 13" />
      </g>
    </svg>
  )
}

export default CloseIcon
